import type {
  AnomalyDirection,
  AnomalyNarrative,
  AnomalyTitleKey,
  MetricPolarity,
} from '../models/anomaly.types'

export interface BuildAnomalyNarrativeInput {
  metricLabel: string
  formattedValue: string
  formattedTarget: string
  direction: AnomalyDirection
  polarity: MetricPolarity
}

function titleKey(polarity: MetricPolarity, direction: AnomalyDirection): AnomalyTitleKey {
  if (polarity === 'higher_is_better' && direction === 'UP') {
    return 'anomalies.narrative.title.jumped'
  }
  if (polarity === 'lower_is_better' && direction === 'UP') {
    return 'anomalies.narrative.title.increased'
  }
  return 'anomalies.narrative.title.dropped'
}

/** Build translation keys and params only; no user-facing sentence is assembled here. */
export function buildAnomalyNarrative(input: BuildAnomalyNarrativeInput): AnomalyNarrative {
  const isBad =
    (input.polarity === 'higher_is_better' && input.direction === 'DOWN') ||
    (input.polarity === 'lower_is_better' && input.direction === 'UP')
  const quality = isBad ? 'bad' : 'good'
  const relation = input.direction === 'DOWN' ? 'below' : 'above'

  return {
    titleKey: titleKey(input.polarity, input.direction),
    titleParams: { metric: input.metricLabel, value: input.formattedValue },
    descriptionKey: `anomalies.narrative.desc.${quality}.${relation}`,
    descriptionParams: { metric: input.metricLabel, target: input.formattedTarget },
  }
}
